import ThemeContext from '@/contexts/ThemeContext';
import { useLocalStorage } from '@/hooks/local-storage';
import createTheme from '@/utils/create-theme';
import { PaletteType } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import React, { useState } from 'react';

type AppThemeProviderProps = React.PropsWithChildren<unknown>;

export default function AppThemeProvider({
  children,
}: AppThemeProviderProps): JSX.Element {
  const { store } = useLocalStorage();
  const currentTheme = store?.getItem('appTheme') || 'light';
  const [type, setType] = useState(currentTheme);

  const theme = createTheme(type as PaletteType);

  const contextValue = {
    currentTheme: type,
    setTheme: (name: string) => {
      store?.setItem('appTheme', name);
      setType(name);
    },
  };

  return (
    <ThemeContext.Provider value={contextValue}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
}
